import * as React from 'react';
import ProjectCreationForm from '../../components/projects/ProjectCreationForm';
import { Box } from '@mui/material';

function ProjectCreationPage(){
    return (
        <Box>
            <h1>Create a new project</h1>
            <ProjectCreationForm/>
        </Box>
    );
}

export default ProjectCreationPage;